import axios from '@/http/index';

const base = '';
// 打印
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);
// 获取打印机列表
export const getPrintSetList = (param) => axios.get(`${base}/erp/print/getPrintSetList`, param).then((res) => res.data);
// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);
// (5.6)获取结算小票打印内容
export const getPrinterOrderCenter = (param) => axios.get(`${base}/erp/customerOrder/getPrinterOrderCenter`, param).then((res) => res.data);
// (6.1)获取结算订单的套餐划扣信息
export const getPackageDeductInfo = (param) => axios.get(`${base}/erp/customerOrder/getPackageDeductInfo`, param).then((res) => res.data);
